import { useParams } from 'react-router-dom';
import { DefaultError } from '@tanstack/query-core';
import { UseSuspenseQueryOptions, useSuspenseQuery } from '@tanstack/react-query';
import { fetchCampaignItem } from 'api/campaigns';
import { useCurrentCampaign } from 'customHooks/useCurrentCampaign';
import { conditionallyFetchOrNull } from 'helpers/reactQuery';
import { campaignQueryKeys } from 'queries/campaign-query-keys';
import { CampaignItem } from 'types/domain';

interface UseCurrentTicketOptions
    extends Omit<
        UseSuspenseQueryOptions<CampaignItem | null, DefaultError, CampaignItem | null, any>,
        'queryKey'
    > {}
const useCurrentTicket = (options: UseCurrentTicketOptions = {}) => {
    const { ticket_id } = useParams<{ ticket_id: string }>();
    const ticketId = ticket_id ? Number(ticket_id) : null;
    const { data: campaign } = useCurrentCampaign();
    const campaignId = campaign!.id;

    return useSuspenseQuery({
        queryKey: campaignQueryKeys.item(campaignId, ticketId!),
        queryFn: () =>
            conditionallyFetchOrNull(
                () => fetchCampaignItem({ campaignId, itemId: ticketId! }),
                !!ticketId,
            ),
        ...options,
    });
};

export { useCurrentTicket };
